import React, { useEffect } from 'react';
import { Button, Typography, Box, Container, CssBaseline } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Function to get query parameters from the URL
    const getQueryParams = (query) => {
        return new URLSearchParams(query);
    };

    const queryParams = getQueryParams(location.search);
    const transactionId = queryParams.get('transaction_id');

    useEffect(() => {
        if (transactionId && typeof window.gtag === 'function') {
            window.gtag('event', 'conversion', {
                send_to: 'AW-16967534462/aKtZCJql6fEaEP6O4Jo_',
                transaction_id: transactionId
            });
    
            console.log('Google Ads conversion event fired');
        } else {
            console.error('Transaction ID missing or gtag not available');
        }
    }, [transactionId]);
    
    
    useEffect(() => {
        if (transactionId && typeof window.gtag === 'function') {
            window.gtag('event', 'purchase', {
                transaction_id: transactionId,
                value: 1.0, // Update with actual amount if available
                currency: 'GBP'
            });
            console.log('GA4 purchase event fired');
        } else {
            console.error('Transaction ID missing or gtag not available');
        }
    }, [transactionId]);

    const handleGoToDashboard = () => {
        navigate('/ParentDashboard');
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Thank you for your purchase!
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Please head to the Parent Dashboard to see your subscription status.
                </Typography>
                <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    onClick={handleGoToDashboard}
                >
                    Go to Parent Dashboard
                </Button>
            </Box>
        </Container>
    );
};

export default PaymentSuccess;
